import { z } from 'zod';
import { ATTENDANCE_STATUS } from '../constants/attendance.constants';
export type { AttendanceStatus } from '../constants/attendance.constants';

export const dailyDashboardItemSchema = z.object({
  zmName: z.string().nullable(),
  zmUserId: z.number().nullable(),
  zmUsername: z.string().nullable(),
  zmMobile: z.string().nullable(),
  zmHrEmpId: z.string().nullable(),
  amUserId: z.number().nullable(),
  amName: z.string().nullable(),
  thana: z.string().nullable(),
  district: z.string().nullable(),
  division: z.string().nullable(),
  status: z.enum(ATTENDANCE_STATUS),
  loginStartTime: z.string().nullable(),
  loginEndTime: z.string().nullable(),
  workTimeStart: z.string().nullable(),
  workTimeEnd: z.string().nullable(),
});

export const jobCardItemSchema = z.object({
  zmName: z.string().nullable(),
  zmUserId: z.number().nullable(),
  zmUsername: z.string().nullable(),
  zmMobile: z.string().nullable(),
  zmHrEmpId: z.string().nullable(),
  amUserId: z.number().nullable(),
  amName: z.string().nullable(),
  deptName: z.string().nullable(),
  thana: z.string().nullable(),
  district: z.string().nullable(),
  division: z.string().nullable(),
  totalDays: z.number(),
  totalWeekends: z.number(),
  totalHolidays: z.number(),
  totalPresentDays: z.number(),
  totalAbsentDays: z.number(),
  specimenQty: z.number().nullable(),
  visitedInstitute: z.number().nullable(),
});

export const employeeInfoSchema = z.object({
  hrEmpId: z.string().nullable(),
  fullName: z.string().nullable(),
  designation: z.string().nullable(),
  department: z.string().nullable(),
  company: z.string().nullable(),
  mobile: z.string().nullable(),
  contactNo: z.string().nullable(),
  address: z.string().nullable(),
  thana: z.string().nullable(),
  district: z.string().nullable(),
  division: z.string().nullable(),
  reportingTo: z.string().nullable(),
});

export const attendanceDaySchema = z.object({
  date: z.string(),
  status: z.enum(ATTENDANCE_STATUS),
  inTime: z.string().nullable(),
  outTime: z.string().nullable(),
  workingHour: z.string().nullable(),
});

export const attendanceSummarySchema = z.object({
  totalDays: z.number(),
  presentDays: z.number(),
  lateDays: z.number(),
  absentDays: z.number(),
  weekendDays: z.number(),
  holidayDays: z.number(),
});

export const employeeReportSchema = z.object({
  employee: employeeInfoSchema,
  attendance: z.array(attendanceDaySchema),
  summary: attendanceSummarySchema,
});

export const dailyDashboardSchema = z.array(dailyDashboardItemSchema);
export const jobCardSchema = z.array(jobCardItemSchema);

export type DailyDashboardItem = z.infer<typeof dailyDashboardItemSchema>;
export type JobCardItem = z.infer<typeof jobCardItemSchema>;
export type EmployeeInfo = z.infer<typeof employeeInfoSchema>;
export type AttendanceDay = z.infer<typeof attendanceDaySchema>;
export type AttendanceSummaryData = z.infer<typeof attendanceSummarySchema>;
export type EmployeeReport = z.infer<typeof employeeReportSchema>;

export interface DailyDashboardParams {
  date: string;
  isActive?: boolean | undefined;
}

export const dailyDashboardSearchSchema = z.object({
  date: z.string().optional(),
  isActive: z.boolean().optional(),
});

export interface JobCardParams {
  dateFrom: string;
  dateTo: string;
  isActive?: boolean | undefined;
}

export const jobCardSearchSchema = z.object({
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  isActive: z.boolean().optional(),
});

export interface EmployeeReportParams {
  userId: number;
  dateFrom?: string;
  dateTo?: string;
}
